/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerAinoCreate
 */
export interface SingleTurnChatInferencerAinoCreate {
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerAinoCreate
   */
  name: string;
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerAinoCreate
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerAinoCreate
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerAinoCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerAinoCreate
   */
  endpointUrl: string;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerAinoCreate
   */
  readonly credentialId: number | null;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerAinoCreate interface.
 */
export function instanceOfSingleTurnChatInferencerAinoCreate(
  value: object,
): value is SingleTurnChatInferencerAinoCreate {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('endpointUrl' in value) || value['endpointUrl'] === undefined) return false;
  if (!('credentialId' in value) || value['credentialId'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerAinoCreateFromJSON(json: any): SingleTurnChatInferencerAinoCreate {
  return SingleTurnChatInferencerAinoCreateFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerAinoCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerAinoCreate {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    endpointUrl: json['endpoint_url'],
    credentialId: json['credential_id'],
  };
}

export function SingleTurnChatInferencerAinoCreateToJSON(
  value?: Omit<SingleTurnChatInferencerAinoCreate, 'credentialId'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    endpoint_url: value['endpointUrl'],
  };
}
